module.exports = ".data-wrapper {\r\n\twidth: auto;\r\n\theight: auto;\r\n}\r\n\r\ntable > tbody > tr > td:first-child {\r\n\tpadding-right: 24px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/data-dialog/data-dialog.component.css
// module id = ./src/app/shared/components/data-dialog/data-dialog.component.css
// module chunks = main